/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */

import type { ResourceStoreContext } from '@atlassian/react-resource-router';
import type { TenantContext } from '@jira/platform__tenant-context-types/src/tenant-context.tsx';

export const getSpaRouterContext = ({
	tenantContext,
}: ResourceStoreContext): {
	tenantContext: TenantContext;
} => ({
	tenantContext,
});
